import { useSelector } from 'react-redux'
import { useMyStrategyTierQuery } from '../queries/useMyStrategyTierQuery'

const COMMENT_TIERS = new Set(['commentOnly', 'full', 'roadmapAdmin'])

// Replaces the old `isReadonlyMode && !isCommentingReadonlyMode` combination (the one place the
// old model's exemption logic showed up) with a direct positive capability check: a user can
// comment if their tier is commentOnly or above. Same no-argument, internally-resolved-roadmap
// shape as useIsRoadmapReadonly -- see the comment there on the loading-state default.
export const useCanCommentOnRoadmap = () => {
    // @ts-expect-error redux store is not typed properly
    const strategyId = useSelector((state) => state?.strategy?._id)
    const { data: tier, isLoading } = useMyStrategyTierQuery(strategyId)

    if (isLoading) return true
    return COMMENT_TIERS.has(tier ?? '')
}
